import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { Match } from '../../_shared/models/match.model';
import { Server } from '../../_shared/models/point.model';
import { Tie } from '../../_shared/models/tie.model';
import { User } from '../../_shared/models/user.model';
import { END_POINT } from '../../../environments/environment';
import { ScoreboardService } from '../scoreboard.service';
import { StatsService } from '../../../app/stats/stats.service';
import { MatchUpStatusEnum } from '../../_shared/models/csTypes/enums/matchup_status';
import { Location } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-playsight',
  templateUrl: './playsight.component.html',
  styleUrls: ['./playsight.component.scss'],
})
export class PlaysightComponent implements OnInit, OnChanges {
  @ViewChildren('participant') participants: QueryList<ElementRef>;

  @Input() match: Match;
  @Input() server: Server;
  @Input() courtName: string;
  @Input() isRetiredOrIncomplete: boolean;
  @Input() showPoints: boolean;
  @Input() side1Color: string;
  @Input() side2Color: string;
  @Input() pointScoreSide1: string;
  @Input() pointScoreSide2: string;
  @Input() statusSide1: string;
  @Input() statusSide2: string;
  @Input() tie: Tie;

  showQrCode = false;
  showInfoBox = false;
  link: string;
  infoBoxText: string;
  streamProvider: string;

  constructor(
    public scoreboardService: ScoreboardService,
    private bhs: BoardHelpService,
    private statsService: StatsService,
    private location: Location
  ) { }

  ngOnInit() {
    document.body.classList.add('transparent')
    this.link = this.match.tie
      ? `${END_POINT}/ties/${this.match.tie}`
      : `${END_POINT}/live-scoring/${this.match._id}`
    
    this.streamProvider = this.location.path().split('/')[3];
    
  }

  async ngOnChanges(change: SimpleChanges) {
    if (change.match?.currentValue) {
      this.showQrCode = false;
      if (this.match.score) {
        this.checkInfoBoxStatus();

        if (this.bhs.getIsChangeOver(this.match)) {
          if (!change.match.isFirstChange()) {
            this.changeQrCodeView();
          }
        }
      }

    }

  }

  getParticipantName(person: User, sideNumber: number, playerIndex: number): string {
    let participantName = ''
    if (person) {
      if (playerIndex === 1) {
        participantName += '/'
      }

      participantName += `${person.first_name.charAt(0)}. ${person.last_name?.toUpperCase()}`;
    } else {
        participantName += this.tie
          ? `${this.getTeamName(sideNumber)} ${this.match.collectionPosition}`
          : `Player ${sideNumber}`
    }

    return participantName;
}

  getTeamName(sideNumber) {
    if (this.tie?.sides[sideNumber - 1]?.team) {
        return `(${this.tie?.sides[sideNumber - 1]?.team.abbreviation})`;
    }

    return null;
  }

  changeQrCodeView() {
      this.showQrCode = true;

      setTimeout(() => {
        this.showQrCode = false;
      }, 30000);
  }

  private checkInfoBoxStatus() {
    const scoreFormat = this.bhs.getScoreFormat(this.match.matchFormat, this.match.discipline);
    const nextToLastPoint = this.bhs.getNextToLastPoint(this.match);
    
    if (this.match.matchStatus !== 'TBP' && this.match.matchStatus !== MatchUpStatusEnum.IN_PROGRESS) {
      this.infoBoxText = this.match.matchStatus;
      this.showInfoBox = true;
    } else if (scoreFormat.lastSetTiebreakTo && this.match.score.sets.length === scoreFormat.numberOfSets) {
      this.infoBoxText = 'SUPER TIE-BREAKER';
      this.showInfoBox = true;
    } else if (nextToLastPoint) {
      if (!scoreFormat.ads && nextToLastPoint.side1Score === 3 && nextToLastPoint.side2Score === 3) {
        this.infoBoxText = 'DECISIVE POINT';
        this.showInfoBox = true;
      } else if (this.statsService.isBreakPoint(nextToLastPoint, scoreFormat)) {
        this.infoBoxText = 'BREAK POINT';
        this.showInfoBox = true;
      }
    } else {
      this.showInfoBox = false;
    }
  }
}
